<div class="dialog-content">
  <!--title 標題-->
  <h1
    class="dialog-title"
    [innerHTML]="'forgot-password-dialog.title' | translate"
  ></h1>

  <!--subtitle 標題-->
  <p class="dialog-subtitle">
    {{ 'forgot-password-dialog.message' | translate }}
  </p>
  <!--btn:關閉按鈕-->
  <button mat-button class="dialog-close-btn" (click)="closeDialog()">
    <img src="assets/img/i-close.svg" alt="" />
  </button>

  <!--dialog 內容-->
  <form
    [formGroup]="forgotPasswordForm"
    (ngSubmit)="onSubmit()"
    class="dialog-form"
  >
    <div class="input-block">
      <label class="input-title input-text-required" for="birthday">{{
        'forgot-password-dialog.birthday' | translate
      }}</label>
      <div class="input-group input-btn-right">
        <input
          id="birthday"
          appDateInput
          matInput
          [matDatepicker]="picker"
          [placeholder]="DATE_FORMAT"
          formControlName="birthday"
          [ngClass]="{
            'input-error':
              showErrorMessage && forgotPasswordForm.get('birthday')?.invalid,
          }"
        />
        <mat-datepicker-toggle [for]="picker" class="input-date-btn">
          <ng-container matDatepickerToggleIcon>
            <img src="assets/img/i-calendar.svg" alt="" />
          </ng-container>
        </mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        @if (showErrorMessage && forgotPasswordForm.get('birthday')?.invalid) {
          <mat-error class="input-error-msg">{{
            getBirthdayErrorMessage()
          }}</mat-error>
        }
      </div>
    </div>
    <div class="input-block">
      <label class="input-title input-text-required" for="idNumber">{{
        'forgot-password-dialog.idNumber' | translate
      }}</label>
      <input
        id="idNumber"
        appAlphaNumericOnly
        matInput
        type="text"
        formControlName="idNumber"
        [placeholder]="
          'forgot-password-dialog.idNumber-placeholder' | translate
        "
        [ngClass]="{
          'input-error':
            showErrorMessage && forgotPasswordForm.get('idNumber')?.invalid,
        }"
        [maxLength]="idNumberMaxLength"
      />
      @if (showErrorMessage && forgotPasswordForm.get('idNumber')?.invalid) {
        <mat-error class="input-error-msg">{{
          getIdNumberErrorMessage()
        }}</mat-error>
      }
    </div>
    <button mat-button type="submit" class="btn-fill-primary btn-size-l">
      {{ 'forgot-password-dialog.send-otp' | translate }}
    </button>
  </form>
</div>
